<script setup lang="ts">
import UserVipInfoBtn from "@/components/Dialogues/Chat/UserVipInfoBtn.vue";
import { isCompactMode } from "@/data/pubilc";
import { isExpand } from "@/views/Home/useData/useHomePage";

import {
  dialogueStatus,
  dialogueList,
  init,
  addDialogue,
} from "@/views/Home/useData/module/dialogue";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { ElMessage } from "element-plus";
import { computed, onMounted } from "vue";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { storeToRefs } from "pinia";
import publicStore from "@/store/publicStore";

const isReplying = computed(() => {
  return chatStatus.isReplying;
});
const { isLogin } = storeToRefs(publicStore());

// onMounted(() => {
//   init();
// });

const addNewDialogue = () => {
  if (!isLogin.value) {
    return openLoginDialog();
  }

  if (isReplying.value) {
    return ElMessage({
      message: "当前对话正在进行中，请先结束当前对话",
      type: "warning",
      duration: 1000,
    });
  }
  addDialogue();
};
</script>

<template>
  <div class="header" :class="{ 'compact-header': isCompactMode }">
    <div class="expand-btn" @click="isExpand = !isExpand" v-if="isCompactMode">
      <img src="../../../assets/open.png" height="18" width="18" />
    </div>

    <div class="right">
      <div v-if="isCompactMode" class="btn" @click="addNewDialogue">
        <img src="@/assets/chat.png" alt="" srcset="" />
      </div>

      <UserVipInfoBtn v-if="false" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  flex-shrink: 0;
  width: 100%;
  height: 42px;
  align-items: center;
  display: flex;
  justify-content: end;
  padding: 0 20px;

  .expand-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    size: 20px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background-color: #dbeafe;
    }
  }

  .right {
    display: flex;
    align-items: center;

    .btn {
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 8px;
      &:hover {
        background-color: #dbeafe;
      }
    }
  }
}

.compact-header {
  padding: 0;
  justify-content: space-between;
}
</style>
